// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgj_a bhj_wj bhj_a bhj_q bhj_k","AdSlotMail__mail--notLoaded":"bgj_b bhj_ey bhj_bj bhj_wy","show-ad-not-loaded":"bgj_c","AdSlotMail__cta":"bgj_e"};